module.exports = __webpack_public_path__ + "img/20190705163133430.735ef271.png";